/**
 * Get a Quote Drawer
 *
 * Opens a right-side drawer holding a HubSpot form on security product pages.
 * Uses its own classes (.td-quote-drawer / .td-quote-drawer-shadow) so it never
 * collides with the cart drawer's `.td-drawer` selectors.
 *
 * The product name / part number / URL live on the drawer root as data-*
 * attributes; when the HubSpot form fires `onFormReady` we copy them into the
 * form's hidden fields (garrett_product_name / _part_number / _url).
 */

function getElements() {
  return {
    drawer: document.querySelector('.td-quote-drawer'),
    shadow: document.querySelector('.td-quote-drawer-shadow'),
  }
}

function openDrawer() {
  const { drawer, shadow } = getElements()
  if (!drawer || !shadow) return

  drawer.classList.add('active')
  shadow.classList.add('active')
  document.body.classList.add('noscroll')
  document.body.style.overflow = 'hidden'
}

function closeDrawer() {
  const { drawer, shadow } = getElements()
  if (!drawer || !shadow) return

  drawer.classList.remove('active')
  shadow.classList.remove('active')
  document.body.classList.remove('noscroll')
  document.body.style.overflow = 'auto'
}

/**
 * Copy the product data from the drawer root into the HubSpot hidden fields.
 * Raw-HTML HubSpot forms render real inline inputs, so this is a direct DOM write.
 */
function populateHiddenFields() {
  const { drawer } = getElements()
  const form = document.querySelector('#garrett-quote-form')
  if (!drawer || !form) return

  const map = {
    garrett_product_name: drawer.dataset.productName,
    garrett_product_part_number: drawer.dataset.productPart,
    garrett_product_url: drawer.dataset.productUrl,
  }

  Object.entries(map).forEach(([name, value]) => {
    if (value == null) return
    const input = form.querySelector(`input[name="${name}"]`)
    if (input) {
      input.value = value
    }
  })
}

export function initializeQuoteDrawer() {
  const { drawer } = getElements()
  if (!drawer) return

  // Open triggers
  document.addEventListener('click', (e) => {
    if (e.target.matches('.js-quote-open, .js-quote-open *')) {
      e.preventDefault()
      openDrawer()
    }
  })

  // Close: button, backdrop
  document.addEventListener('click', (e) => {
    if (e.target.matches('.td-quote-drawer__close, .td-quote-drawer__close *, .td-quote-drawer-shadow')) {
      closeDrawer()
    }
  })

  // Close: Esc
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer()
    }
  })

  // Populate hidden fields once the HubSpot form is ready
  window.addEventListener('message', (e) => {
    if (e.data?.type === 'hsFormCallback' && e.data.eventName === 'onFormReady') {
      populateHiddenFields()
    }
  })
}
